export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_710_SEARCH': 'Search',
    '_7360_FILTER': 'Filter',
    '_127_STATUS': 'Status',
    '_709_DATE_RANGE': 'Date Range',
    '_11237_CLEAR_DATE_FILTERS': 'Clear Date Filters',
    '_9468_SORT': 'Sort',
    '_7216_SORT_BY': 'Sort by',
    '_11238_IMPORTANT': 'Important',
    '_11239_EARLIEST_DUE_DATE': 'Earliest Due Date',
    '_11240_LATEST_DUE_DATE': 'Latest Due Date',
    '_11241_CREATION_DATE': 'Creation Date',
    '_11242_ALPHABETICAL__A_Z': 'Alphabetical: A-Z',
    '_11243_ALPHABETICAL__Z_A': 'Alphabetical: Z-A'
};
